import { ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

import { ShapeType } from './utils.types'

export const cn = (...args: ClassValue[]) => {
    return twMerge(clsx(...args))
}

/** Shape styles controller */
/* 
    It gets shape and existing arguments 
    and pass utility classes depending on the  shape of the component
    Shape can be square or rounded
*/
export const getShapeClasses = (shape: ShapeType): string => {
    const shapeClasses: Record<ShapeType, string> = {
        square: 'rounded-lg',
        rounded: 'rounded-full',
        group: 'rounded-none',
        circle: 'rounded-full',
    }

    return shapeClasses[shape] || '' // Fallback to empty string if shape is not found
}
export { type ColorType, type VariantClassesProps } from './utils.types'

export { useCreateElement } from './customHooks'

export { getCssVariable } from './getCssVariable'

export { useThemeAttribute } from './useThemeAttribute'
